import {fromBech32, toBech32} from "@cosmjs/encoding";
import {isObjectId} from "./ExactInteger";

/**
 * @param {string} address
 * @return {string} the address, once it is a canonical structs bech32 account address
 */
export function transferAddress(address) {
  if (typeof address !== 'string') {
    throw new Error('Transfer address is required');
  }
  const decoded = fromBech32(address);
  if (
    decoded.prefix !== 'structs'
    || decoded.data.length !== 20
    || toBech32(decoded.prefix, decoded.data) !== address
  ) {
    throw new Error('Invalid transfer address');
  }
  return address;
}

/**
 * Validate a transfer intent. It holds the user's choices only; protocol,
 * source, destination and authority are resolved before signing.
 *
 * @param {object} value
 * @return {Readonly<object>}
 */
export function transferIntent(value) {
  const fields = ['kind', 'version', 'ownerId', 'recipientId', 'recipientAddress', 'amount'];
  if (
    !value
    || typeof value !== 'object'
    || Array.isArray(value)
    || Object.keys(value).length !== fields.length
    || Object.keys(value).some(key => !fields.includes(key))
    || value.kind !== 'alpha_transfer'
    || value.version !== 1
  ) {
    throw new Error('Invalid transfer intent');
  }
  for (const id of [value.ownerId, ...(value.recipientId === null ? [] : [value.recipientId])]) {
    if (!isObjectId(id, 1)) {
      throw new Error('Invalid transfer player');
    }
  }
  transferAddress(value.recipientAddress);
  if (
    typeof value.amount !== 'string'
    || !/^[1-9][0-9]{0,7}$/.test(value.amount)
    || BigInt(value.amount) > 99000000n
    || BigInt(value.amount) % 1000000n !== 0n
  ) {
    throw new Error('Transfer amount must be a whole Alpha from 1 through 99');
  }
  return Object.freeze({...value});
}
